import type { ScaleOrderResult } from "@mesketch/engine";

// „Zatím vedou“ (CR-012 §6) po místech: škály z `top` seskupené podle sdíleného místa, aby shoda
// na hranici (po prvním kole jich může být víc než `top`) byla vidět jako jedno místo, ne dlouhý
// seznam (Libor 19. 10. 2026).

export interface LeadingGroup {
  readonly place: number;
  readonly scales: readonly string[];
}

export function leadingGroups(order: Pick<ScaleOrderResult, "scales" | "top">): LeadingGroup[] {
  const top = new Set(order.top);
  const groups: { place: number; scales: string[] }[] = [];
  for (const s of order.scales) {
    if (!top.has(s.scale)) continue;
    const last = groups.at(-1);
    if (last?.place === s.place) last.scales.push(s.scale);
    else groups.push({ place: s.place, scales: [s.scale] });
  }
  return groups;
}

/** Nejvýš tolik názvů ukáže souhrn Skici „Tvoje nejsilnější“. */
export const SUMMARY_MAX = 5;

export interface SummaryLeaders {
  /** Škály po celých místech, dohromady nejvýš `SUMMARY_MAX`. */
  readonly scales: readonly string[];
  /** Shoda, která se do souhrnu nevešla: kolik škál a o které místo se dělí. */
  readonly more: { readonly count: number; readonly place: number } | null;
}

/**
 * Souhrn Skici u testu s pořadím (CR-014 §2, Libor 19. 10. 2026): celá místa, dokud se vejdou
 * do `SUMMARY_MAX` názvů, první shoda, která se nevejde, jako počet na společném místě. Velká
 * věta s deseti názvy se jinak nečte.
 */
export function summaryLeaders(order: Pick<ScaleOrderResult, "scales" | "top">, max = SUMMARY_MAX): SummaryLeaders {
  const scales: string[] = [];
  for (const g of leadingGroups(order)) {
    if (scales.length + g.scales.length > max) return { scales, more: { count: g.scales.length, place: g.place } };
    scales.push(...g.scales);
  }
  return { scales, more: null };
}
